import red from "@material-ui/core/colors/red";
import Button from "@material-ui/core/Button";
import classNames from "classnames";
import {withStyles} from "@material-ui/core";
import React from "react";
import { grey } from "@material-ui/core/colors";

const styles = theme => ({
    margin: {
        marginTop: '40px',
        padding: '10px'
    },
    cssRoot: {
        // color: theme.palette.getContrastText(grey[500]),
        backgroundColor: grey[500],
        '&:hover': {
            backgroundColor: grey[700],
        },
    },
});

function PrintButton({visible, onClick, disabled, classes, submitted}) {
    if (visible) {
        return (
            <Button
                variant="contained"
                color="primary"
                onClick={onClick}
                className={classNames(classes.margin, classes.cssRoot)}
                disabled={disabled || submitted}
            >
                {"ΟΛΟΚΛΗΡΩΣΗ ΠΑΡΑΓΓΕΛΙΑΣ"}
            </Button>
        )
    }
    return null;
}

export default withStyles(styles)(PrintButton);